import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";
import { useRemoteFeatureFlags } from "../../../../../../../../hooks/useRemoteFeatureFlags";
import { SELLAR_CREDIT_TWO_BUSINESS_REGISTRATION_APPLICATION } from "../../../../../../../../constants/routes";
import { Button, H2, Icon } from "@sellar-io/components";
import { useIntercom } from "react-use-intercom";
import { SellarCreditTwoDialogPage } from "./SellarCreditTwoDialogPage";

export const TwoBusinessRegistrationApplication = () => {
  const { onDismiss } = useFullPageDialogContext();
  const intercom = useIntercom();

  const { isActive } = useRemoteFeatureFlags();

  const isSellarCreditApplicationForSoleTradersEnabled = isActive(
    "enableSellarCreditForSoleTraders",
  );

  if (!isSellarCreditApplicationForSoleTradersEnabled) {
    return (
      <SellarCreditTwoDialogPage contentClassName="gap-4">
        <img
          src="https://sellar.imgix.net/sellar-image-assets/app-assets/sellarxtwo.svg"
          className="w-[320px] shrink-0"
        />

        <div className="mt-16 flex flex-col items-center gap-8">
          <H2>
            Unfortunately we can't get you set up as a Sole Trader right now
          </H2>

          <div className="flex flex-col items-center gap-4">
            <p>If you wish to apply, please reach out to the team</p>

            <Button
              color={"secondary"}
              className={"w-48 p-4"}
              onClick={() => intercom.show()}
            >
              <div className="flex items-center gap-1">
                <Icon
                  icon="HELP_CIRCLE_OUTLINE"
                  size={1}
                  className="shrink-0"
                />
                Contact support
              </div>
            </Button>
          </div>
        </div>

        <div className="mt-auto flex w-full flex-col gap-2">
          <Button className="w-full" onClick={() => onDismiss?.()}>
            Go back
          </Button>
        </div>
      </SellarCreditTwoDialogPage>
    );
  }

  return (
    <SellarCreditTwoDialogPage contentClassName="gap-2">
      <img
        src="https://sellar.imgix.net/sellar-image-assets/app-assets/sellarxtwo.svg"
        className="my-2 w-[320px] shrink-0"
      />

      <H2 className="mt-8">Business Registration</H2>
      <p className="mb-12">
        Before your credit application you are required to register your
        business, please follow the link to complete your application.{" "}
      </p>

      <div className="flex w-full flex-col gap-2">
        <Button
          className="w-full"
          onClick={() => {
            onDismiss?.();
            const twoBusinessRegistrationApplication = `${import.meta.env.VITE_URL}${SELLAR_CREDIT_TWO_BUSINESS_REGISTRATION_APPLICATION}`;
            window.open(twoBusinessRegistrationApplication, "_blank");
          }}
        >
          CONTINUE TO REGISTRATION
        </Button>
      </div>
    </SellarCreditTwoDialogPage>
  );
};
